module.exports = __webpack_public_path__ + "assets/Angle30Detailed.7ed3dea5e5b9c258ac78557d37f5daa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle30Detailed.png
// module id = 459
// module chunks = 0